/* eslint-disable react/jsx-indent */

/* eslint-disable react/jsx-wrap-multilines */
import * as React from "react";
import {
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  Switch,
  TextField,
} from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import CheckBoxFormik from "../../checkbox/CheckBoxFormik";
import { getStates } from "../../../../services/AgapeAPI";
import AgapeIcon from "../../icons/AgapeIcon";

const useStyles = makeStyles((theme) => ({
  allFilter: {
    // paddingBottom: '10px',
    borderBottom: "1px solid #dedede",
    // backgroundColor: '#fafaff',
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  },
  switchLabel: {
    "& .MuiFormControlLabel-label": {
      fontFamily: "Vazir-Medium",
      fontSize: "1.4rem !important",
      color: "black",
    },
  },
  searchField: {
    padding: "0 15px 0 0",
    borderRadius: "16px",
    // border: 'none',
    fontFamily: "VazirFD",
    width: "90%",
    outline: "none",
    border: "2px solid #dadada",

    "& .MuiOutlinedInput-adornedStart": {
      padding: "0 !important",
    },
  },
  selectField: {
    // maxWidth: '45%',
    padding: "10px 23px",
    top: "0 !important",
    "& div": {
      top: "0 !important",
      left: "0 !important",
    },
  },
  inputField: {
    // maxWidth: '45%',
    padding: "10px 30px",
  },
  searchContainer: {
    // height: '34.5px !important',
  },
  singleCheckBox: {
    padding: "0 30px",
  },
  singleContainer: {
    height: "137px",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "14px",
      height: "18px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ededed",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "6px",
      border: "4px solid rgba(0, 0, 0, 0)",
      backgroundClip: "padding-box",
      backgroundColor: "#8898aa",
      borderRadius: "50px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#525b67",
    },
  },
  closeBtn: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const DataContainer = ({
  name,
  data,
  value,
  onChange,
  setCities,
  all,
  allName,
  setFieldValue,
  searchValue,
  searchName,
  storeUpdater,
  reduxField,
}) => {
  const classes = useStyles();
  const [allValues, setAllValues] = React.useState(
    data ? data.map((el) => el.id.toString()) : []
  );

  const emptySearch = () => {
    setFieldValue(searchName, "");
    setFieldValue(name, []);
    if (storeUpdater) {
      storeUpdater(reduxField, []);
    }
  };
  React.useEffect(() => {
    if (data) {
      const tempAll = data
        .filter((el) => el.name.includes(searchValue))
        .map((el2) => el2.id.toString());

      setAllValues(tempAll);
    }
  }, [searchValue, setAllValues, data]);

  React.useEffect(() => {
    // if (name === 'state') {
    //   const tempAll = data
    //     .filter((el) => el.name.includes(searchValue))
    //     .map((el2) => el2.id.toString());
    //   getStates(`?filter[id]=${all ? tempAll : ''}&include=cities`).then(
    //     (resp) => {
    //       const allCities = resp.data.data.map((s) => s.cities);
    //       let allTemp = [];
    //       allCities.forEach((ac) => {
    //         allTemp = allTemp.concat(ac);
    //       });
    //       setCities(allTemp);
    //     }
    //   );
    // }
  }, [all]);
  return (
    <Grid container justify="space-between" alignItems="center">
      <Grid
        item
        container
        alignItems="center"
        justify="space-between"
        md={12}
        className={classes.allFilter}
      >
        <Grid item md={6} className={classes.inputField}>
          <TextField
            name={searchName}
            variant="outlined"
            placeholder="جستجو کنید..."
            value={searchValue}
            onChange={onChange}
            className={classes.searchField}
            InputProps={{
              startAdornment: (
                <IconButton onClick={emptySearch} className={classes.closeBtn}>
                  <AgapeIcon icon="close" size="1.2rem" />
                </IconButton>
              ),
            }}
          />
        </Grid>
        <Grid item md className={classes.selectField}>
          <FormControlLabel
            control={
              <Switch
                name={allName}
                checked={all}
                onChange={(e) => {
                  onChange(e);
                  if (all) {
                    setFieldValue(name, []);
                    if (storeUpdater) {
                      storeUpdater(reduxField, []);
                    }
                  } else {
                    setFieldValue(name, allValues);
                    if (storeUpdater) {
                      storeUpdater(reduxField, allValues);
                    }
                  }
                }}
              />
            }
            label="انتخاب همه"
            className={classes.switchLabel}
          />
        </Grid>
      </Grid>
      <Grid
        item
        md={12}
        container
        alignItems="center"
        className={classes.singleContainer}
      >
        {data
          ? data
              .filter((el) => el.name.includes(searchValue))
              .map((element) => (
                <Grid
                  item
                  md={6}
                  key={element.name}
                  className={classes.singleCheckBox}
                >
                  <CheckBoxFormik
                    type="checkbox"
                    name={name}
                    value={element.id}
                    onChange={async (e) => {
                      onChange(e);
                      const tI = value.indexOf(e.target.value.toString());
                      const tempValue = Array.from(value);
                      if (tI > -1) {
                        tempValue.splice(tI, 1);
                      } else {
                        tempValue.push(e.target.value);
                      }
                      if (storeUpdater) {
                        storeUpdater(reduxField, tempValue);
                      }
                      if (name === "state") {
                        getStates(
                          `?filter[id]=${
                            tI === -1 ? `${e.target.value},` : ""
                          }${value}&include=cities`
                        ).then((resp) => {
                          const allCities = resp.data.data.map((s) => s.cities);
                          let allTemp = [];
                          allCities.forEach((ac) => {
                            allTemp = allTemp.concat(ac);
                          });
                          setCities(allTemp);
                        });
                      }
                    }}
                    checked={value.includes(element.id.toString())}
                    label={element.name}
                    // className={classes.checkboxLabel}
                  />
                </Grid>
              ))
          : [0, 0, 0, 0, 0, 0, 0, 0, 0].map((element) => (
              <Grid
                item
                md={6}
                key={element.name}
                className={classes.singleCheckBox}
              >
                <Skeleton />
              </Grid>
            ))}
      </Grid>
    </Grid>
  );
};

export default DataContainer;
